import React from "react";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import { GetQuoteData } from "./GetQouteData";
import { useLocation } from "react-router-dom";
import { useProductEnquiry } from "../../hooks/useProductEnquiry";
import { useServiceEnquiry } from "../../hooks/useServiceEnquiry";
import CustomSelect from "../../components/common/CustomDropDown/CustomSelect";

type InterestType = "product" | "service";

type FormData = {
  name: string;
  email: string;
  mobile: string;
  interestType: "" | "Product" | "Service";
  interestItem: string;
  message: string;
};

type FormErrors = Partial<Record<keyof FormData, string>>;

const interestOptions: Record<InterestType, string[]> = {
  product: [
    "Pro-Lab GB II",
    "Pro-Lab GB III",
    "Pro-Lab GB IV",
    "Custom Glovebox System",
  ],
  service: [
    "Glovebox Inspection & Preventive Maintenance",
    "Vacuum & Inert Gas System Servicing",
    "Filter & Purification Media Replacement",
    "Seal, Gasket & O-Ring Replacement",
    "Sensor Cleaning & Calibration",
    "Customization & Technical Support",
  ],
};

export default function GetQuote() {
const { submitProductEnquiry} = useProductEnquiry();
 const { submitServiceEnquiry } = useServiceEnquiry();
   const location = useLocation();
  React.useEffect(() => {
    if (location.hash) {
      const sectionId = location.hash.replace("#", "");
      const element:any = document.getElementById(sectionId);
      const headerOffset = 120; // pixels you want to keep above
      const elementPosition =
        element.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - headerOffset;
      if (element) {
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [location]);

  const [formData, setFormData] = React.useState<FormData>({
    name: "",
    email: "",
    mobile: "",
    interestType: "",
    interestItem: "",
    message: "",
  });

  const [errors, setErrors] = React.useState<FormErrors>({});
  const [dependentOptions, setDependentOptions] = React.useState<string[]>([]);
  const [submitted, setSubmitted] = React.useState(false);

const handleChange = (
  e: React.ChangeEvent<
    HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
  >
) => {
  const { name, value } = e.target;

  /* ================= NAME ================= */
  if (name === "name") {
    const onlyAlphabets = value.replace(/[^a-zA-Z\s]/g, "");

    setFormData((prev) => ({ ...prev, name: onlyAlphabets }));

    setErrors((prev) => {
      const updated = { ...prev };

      if (onlyAlphabets.trim().length === 0) {
        updated.name = "Full Name is required";
      } else if (onlyAlphabets.trim().length < 2) {
        updated.name = "Full Name must be at least 2 characters";
      } else {
        delete updated.name;
      }

      return updated;
    });

    return;
  }

  /* ================= MOBILE ================= */
  if (name === "mobile") {
    const onlyNumbers = value.replace(/[^0-9]/g, "");

    setFormData((prev) => ({ ...prev, mobile: onlyNumbers }));

    setErrors((prev) => {
      const updated = { ...prev };

      if (onlyNumbers.length === 0) {
        updated.mobile = "Mobile number is required";
      } else if (!/^[6-9]/.test(onlyNumbers)) {
        updated.mobile = "Mobile must start with 6–9";
      } else if (onlyNumbers.length < 10) {
        updated.mobile = "Enter 10 digit mobile number";
      } else if (onlyNumbers.length > 10) {
        updated.mobile = "Mobile number cannot exceed 10 digits";
      } else {
        delete updated.mobile;
      }

      return updated;
    });

    return;
  }

  /* ================= EMAIL ================= */
  if (name === "email") {
    const emailValue = value.replace(/\s/g, "");
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    setFormData((prev) => ({ ...prev, email: emailValue }));

    setErrors((prev) => {
      const updated = { ...prev };

      if (emailValue.length === 0) {
        updated.email = "Email is required";
      } else if (!emailRegex.test(emailValue)) {
        updated.email = "Enter a valid email address";
      } else {
        delete updated.email;
      }

      return updated;
    });

    return;
  }

  /* ================= OTHER FIELDS ================= */
  setFormData((prev) => ({
    ...prev,
    [name]: value,
    ...(name === "interestType" ? { interestItem: "" } : {}),
  }));

  setErrors((prev) => {
    const updated = { ...prev };
    if (!value) updated[name as keyof FormData] = "This field is required";
    else delete updated[name as keyof FormData];
    return updated;
  });

  /* ================= DEPENDENT DROPDOWN ================= */
  if (name === "interestType") {
    const key = value.toLowerCase() as "product" | "service";
    setDependentOptions(interestOptions[key] || []);
  }
};



  const validate = (): FormErrors => {
    const newErrors: FormErrors = {};

    if (!formData.name.trim()) newErrors.name = "Full name is required";
     if (!formData.email?.trim()) {
    newErrors.email = "Email is required";
  } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
    newErrors.email = "Enter a valid email";
  }
    if (!formData.mobile?.trim()) {
  newErrors.mobile = "Mobile number is required";
} else {
  const cleanedMobile = formData.mobile
    .replace(/\s+/g, "")     // remove spaces
    .replace(/^(\+91|0)/, ""); // remove +91 or leading 0

  if (!/^[6-9]\d{9}$/.test(cleanedMobile)) {
    newErrors.mobile = "Enter a valid 10-digit mobile number";
  }
}

    if (!formData.interestType)
      newErrors.interestType = "Please select an interest";
    if (!formData.interestItem)
      newErrors.interestItem = "Please select a product or service";
    if (!formData.message.trim())
      newErrors.message = "Please enter requirement details";

    return newErrors;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      console.log("Form Submitted:", formData);
      if(formData.interestType === 'Product'){
        const result = await submitProductEnquiry(formData);
      }
      if(formData.interestType === 'Service'){
        const result = await submitServiceEnquiry(formData);
      }
      setSubmitted(true);
    }
  };
  React.useEffect(() => {
    if (location.hash) {
      const sectionId = location.hash.replace("#", "");
      const element: any = document.getElementById(sectionId);
      const headerOffset = 120; // pixels you want to keep above
      const elementPosition =
        element.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - headerOffset;
      if (element) {
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [location]);


  return (
    <>
      {/* HERO */}
      <section
              className="relative h-[200px] md:h-[300px] flex items-center justify-center bg-cover bg-center mt-[80px]"
              style={{
                backgroundImage: `url(${GetQuoteData.heroData.imgUrl})`,
              }}
            >
              {/* Gradient overlay */}
              <div className="absolute inset-0  bg-gradient-to-b from-gray-900/60 via-gray-900/90 to-gray-900"></div>
              <div className="relative z-10 text-center px-4 max-w-3xl">
                <h1 className="text-[#ff1a1a] font-extrabold uppercase text-3xl md:text-4xl lg:text-5xl tracking mb-2">
                  {GetQuoteData.heroData.title}
                  <span className="text-white">{GetQuoteData.heroData.title2}</span>
                </h1>
                <div className="w-20 h-1 bg-[#ff1a1a] mx-auto rounded-full mb-4"></div>
                <p className="text-white text-base md:text-lg font-workSans font-medium">
                  {GetQuoteData.heroData.subTitle}
                </p>
              </div>
            </section>


      {/* CONTENT */}
      <section className="max-w-7xl mx-auto py-16 px-4 grid grid-cols-1 lg:grid-cols-2 gap-10">
        {/* LEFT INFO */}
        <div
          className="relative h-[580px] bg-cover bg-center bg-no-repeat flex-shrink-0 rounded-xl overflow-hidden"
          style={{
            backgroundImage: `url(${GetQuoteData.formData.leftSection.imgUrl})`,
          }}
        >
          {/* Gradient + Dark Overlay */}
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 to-black/70"></div>

          {/* Decorative Vector */}
          <div className="absolute top-0 right-0 w-40 h-40 opacity-20">
            <svg viewBox="0 0 200 200" className="w-full h-full text-white/40">
              <path d="M0 50 L200 0 L200 20 L0 70 Z" fill="currentColor" />
            </svg>
          </div>

          {/* Content */}
          <div className="relative z-10 text-white p-10 lg:p-14 flex flex-col justify-between h-full">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold leading-tight">
                {GetQuoteData.formData.leftSection.title} <br />
                {GetQuoteData.formData.leftSection.titleAlt}
              </h2>

              <p className="text-white/80 mt-4 text-lg leading-relaxed max-w-md">
                {GetQuoteData.formData.leftSection.description}
              </p>

              {/* <div className="mt-6">
                <img
                  src={GetQuoteData.formData.leftSection.iconUrl}
                  alt="ProRes Icon"
                  className="w-16 opacity-80"
                />
              </div> */}
            </div>

            {/* Contact Info */}
            <div className="space-y-4 mt-10">
              <div className="flex items-center gap-3">
                <FaMapMarkerAlt className="text-red-500 text-lg" />
                <p className="text-white/90">
                  {GetQuoteData.formData.leftSection.address}
                </p>
              </div>

              <div className="flex items-center gap-3">
                <FaPhoneAlt className="text-red-500 text-lg" />
                <p className="text-white/90">
                  {GetQuoteData.formData.leftSection.mobileNUmber}
                </p>
              </div>

              <div className="flex items-center gap-3">
                <FaEnvelope className="text-red-500 text-lg" />
                <p className="text-white/90">
                  {GetQuoteData.formData.leftSection.emailAddress}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT FORM */}
        <div className="bg-white rounded-xl p-10 shadow-lg" id="quote-form">
          {submitted ? (
            <div className="text-center py-20">
              <h3 className="text-3xl font-bold text-green-600 mb-4">
                Thank You!
              </h3>
              <p className="text-gray-600">
                Your quote request has been submitted successfully.
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-6">
        {[
  { name: "name", label: "Full Name", type: "text", required: true },
  { name: "email", label: "Email Address", type: "email", required: true },
  { name: "mobile", label: "Mobile Number", type: "tel", required: true },
].map((field) => (
  <div key={field.name} className="relative">
    <input
      id={field.name} // ✅ REQUIRED
      type={field.type}
      name={field.name}
      value={formData[field.name as keyof FormData] || ""}
      onChange={handleChange}
      placeholder={field.label}
      inputMode={field.name === "mobile" ? "numeric" : undefined}
      maxLength={field.name === "mobile" ? 10 : undefined}
      className="peer w-full border-b-2 border-gray-300 py-3 outline-none
                 focus:border-red-600 placeholder-transparent"
    />

    <label
      htmlFor={field.name} // ✅ REQUIRED
      className="absolute left-0 top-3 text-gray-500 text-sm transition-all cursor-text
                 peer-placeholder-shown:top-3 peer-placeholder-shown:text-base
                 peer-placeholder-shown:text-gray-400
                 peer-focus:-top-2 peer-focus:text-sm peer-focus:text-red-600
                 peer-[&:not(:placeholder-shown)]:-top-2
                 peer-[&:not(:placeholder-shown)]:text-sm"
    >
      {field.label}
      {field.required && <span className="text-red-600"> *</span>}
    </label>

    {errors[field.name as keyof FormData] && (
      <p className="text-red-600 text-sm mt-1">
        {errors[field.name as keyof FormData]}
      </p>
    )}
  </div>
))}



<CustomSelect
  id="interestType"
  label="Select Interest"
  required
  value={formData.interestType}
  options={["Product", "Service"]}
  onChange={(val: string) => {
    handleChange({ target: { name: "interestType", value: val } } as any);
    setDependentOptions(interestOptions[val.toLowerCase() as "product" | "service"] || []);
  }}
  error={errors.interestType}
/>

{dependentOptions.length > 0 && (
  <CustomSelect
    id="interestItem"
    label="Select Option"
    required
    value={formData.interestItem}
    options={dependentOptions}
    onChange={(val: string) =>
      handleChange({ target: { name: "interestItem", value: val } } as any)
    }
    error={errors.interestItem}
  />
)}




              {/* MESSAGE */}
   <div className="relative">
  <textarea
    rows={4}
    name="message"
    id="message"
    value={formData.message || ""}
    onChange={handleChange}
    placeholder="Requirement Details"
    className="peer w-full border-b-2 border-gray-300 py-3 outline-none
               focus:border-red-600 resize-none placeholder-transparent"
  />

  <label
    htmlFor="message"
    className={`absolute left-0 transition-all cursor-text
      ${formData.message
        ? "-top-2 text-sm text-red-600"
        : "top-3 text-gray-500 text-base"
      } peer-focus:-top-2 peer-focus:text-sm peer-focus:text-red-600`}
  >
    Requirement Details <span className="text-red-600">*</span>
  </label>

  {errors.message && (
    <p className="text-sm text-red-600 mt-1">
      {errors.message}
    </p>
  )}
</div>






              {/* SUBMIT */}
              <button
                type="submit"
                className="bg-red-600 hover:bg-red-700 text-white px-10 py-4 rounded-md font-semibold"
              >
                Request Quote
              </button>
            </form>
          )}
        </div>
      </section>
    </>
  );
}
